import React, { useEffect, useState } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { useTranslations } from '../../contexts/translationContext';
import { StringWithFormat } from "../../types/Result";

interface ActionMenuProps {
    title: string | StringWithFormat
    children?: React.ReactNode
}

const ActionMenu: React.FC<ActionMenuProps> = ({ title, children }) => {
    const [titleText, setTitleText] = useState<string>('')
    const { translate } = useTranslations();

    useEffect(() => {
        if (title) {
            translate('ActionMenu.Title: ' + title, undefined, title).then(translated => setTitleText(translated));
        }
    }, [title]);

    return (
        <DropdownButton id="actions-dropdown" className="dropdown-with-icons actionMenu" variant="secondary" title={titleText} >
            <>
                {children}
            </>
        </DropdownButton>
    )
}
export default ActionMenu